import { Action } from '@ngrx/store';

export const TYPE = '[Classification] Type';
export const TYPE_RESULTS = '[Classification] Type Results';

export const WIDTH = '[Classification] Width';
export const WIDTH_RESULTS = '[Classification] Width Results';

export const FISH = '[Classification] Fish Pass';
export const FISH_RESULTS = '[Classification] Fish Pass Results';

export const SPAM = '[Classification] Spam';

export const FAILURE = '[Classification] Failure';

export class Type implements Action {
    readonly type = TYPE;
    constructor(public barrierType: string) { }
}
export class TypeResults implements Action {
    readonly type = TYPE_RESULTS;
    constructor(public data: any[], public labels: any[]) { }
}

export class Width implements Action {
    readonly type = WIDTH;
    constructor(public isFullWidth: string) { }
}
export class WidthResults implements Action {
    readonly type = WIDTH_RESULTS;
    constructor(public data: any[], public labels: any[]) { }
}

export class Fish implements Action {
    readonly type = FISH;
    constructor(public hasFishPass: string) { }
}
export class FishResults implements Action {
    readonly type = FISH_RESULTS;
    constructor(public data: any[], public labels: any[]) { }
}

export class Spam implements Action {
    readonly type = SPAM;
    constructor() { }
}

export class Failure implements Action {
    readonly type = FAILURE;
    constructor(public error: string) { }
}


export type All = Type | TypeResults | Width | WidthResults | Fish | FishResults | Spam;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/actions/classification.actions.ts